import type { BrandTheme } from './brand';

export function applyBrandTheme(brand: BrandTheme) {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', brand.primaryColor);
  root.style.setProperty('--brand-accent', brand.accentColor);
  document.title = `${brand.name} — Estúdio`;
}
